export default __webpack_public_path__ + "static/media/pic2.15acaed8.jpg";